import styles from "./styles.module.css";
import Image from "@/shared/components/Image/new";

const NotasRelacionadas = (props) => {
  const urlLink = process.env.NEXT_PUBLIC_DOMAIN_URL;
  const { content } = props;

  const lilanews = content.value ?? {};

  const selectedView = content.customData?.selectedView ?? "normal";

  const viewClassByType = {
    Normal: styles["nr-container--normal"],
    Destacada: styles["nr-container--destacada"],
    Bullet: styles["nr-container--bullet"],
  };

  const containerClassName = [
    styles["nr-container"],
    styles["paragraph-detail"],
    viewClassByType[selectedView] ?? viewClassByType.normal,
  ]
    .filter(Boolean)
    .join(" ");

  const element =
    lilanews &&
    lilanews.images &&
    lilanews.images[0] &&
    lilanews.images[0].value && {
      images: [
        {
          clippings: lilanews.images[0].value.clippings || [],
        },
      ],
    };

  return (
    <>
      {lilanews && lilanews.url && (
        <a
          className={containerClassName}
          href={`${urlLink}${lilanews.url}`}
        >
          {lilanews.title && content.titleNewsEmbed && (
            <span className={styles["h4"]}>
              {content.titleNewsEmbed}
            </span>
          )}

          {element && (
            <Image
              element={element}
              clipping="3_2_248x166"
              className={styles["image"]}
            />
          )}

          {lilanews.title && (
            <span className={styles["h3"]}>
              {lilanews.title}
            </span>
          )}
        </a>
      )}
    </>
  );
};

export default NotasRelacionadas;